import { DataSensorSearchInputs } from "../../pages/analysis/SensorPage";
import { ChangeEvent, useState } from "react";
import { SelectOption } from "../types/selectOption";
import { useQuery } from "@tanstack/react-query";
import { request } from "../../common/api";
import {
  GET_LOW_MACHINERY_SELECT_OPTIONS,
  GET_MACHINERY_SELECT_OPTIONS,
  GET_SENSOR_SELECT_OPTIONS,
  GET_SHIP_SELECT_OPTIONS,
  // GET_SHIP_TYPE_SELECT_OPTIONS,
} from "../query-keys";

const useSensorSearchInputData = (
  searchDefaultValues: DataSensorSearchInputs
) => {
  const [search, setSearch] =
    useState<DataSensorSearchInputs>(searchDefaultValues);

  // // 함형 options 조회
  // const { data: shipTypeSelectOptions } = useQuery<SelectOption[]>({
  //   queryKey: [GET_SHIP_TYPE_SELECT_OPTIONS, "all"],
  //   queryFn: async () => {
  //     const result = await request<SelectOption[]>({
  //       method: "GET",
  //       url: "/equipment-code/select/options",
  //     });
  //     return [{ label: "전체", value: "" }, ...result];
  //   },
  // });

  // // 함정 options 조회
  // const { data: shipSelectOptions } = useQuery<SelectOption[]>({
  //   queryKey: [GET_SHIP_SELECT_OPTIONS, search.ssrShiptypeName],
  //   queryFn: async () => {
  //     if (!search.ssrShiptypeName) {
  //       return [];
  //     }

  //     return await request<SelectOption[]>({
  //       method: "GET",
  //       url: `/ship-info/select/options/${search.ssrShiptypeName}`,
  //     });
  //   },
  // });

  // 장비 options 조회
  const { data: machinerySelectOptions } = useQuery<SelectOption[]>({
    queryKey: [GET_MACHINERY_SELECT_OPTIONS, search.ssrShipNo],
    queryFn: async () => {
      if (!search.ssrShipNo) {
        return [];
      }
      return await request<SelectOption[]>({
        method: "GET",
        url: `/equipment-info/machinery/select/options/${search.ssrShipNo}`,
      });
    },
  });

  // 하위장비 options 조회
  const { data: lowMachinerySelectOptions } = useQuery<SelectOption[]>({
    queryKey: [GET_LOW_MACHINERY_SELECT_OPTIONS, search.ssrMachine],
    queryFn: async () => {
      if (!search.ssrMachine) {
        return [];
      }

      return await request<SelectOption[]>({
        method: "GET",
        url: `/equipment-info/low-machinery/select/options/${search.ssrMachine}`,
      });
    },
  });

  // 센서 options 조회
  const { data: sensorSelectOptions } = useQuery<SelectOption[]>({
    queryKey: [
      GET_SENSOR_SELECT_OPTIONS,
      search.ssrLowMcyName,
      search.ssrSignal,
    ],
    queryFn: async () => {
      if (!search.ssrLowMcyName) {
        return [];
      }

      return await request<SelectOption[]>({
        method: "GET",
        url: `/sensor/select/options`,
        params: {
          ssrShipNo: search.ssrShipNo,
          ssrMcyName: search.ssrMcyName,
          ssrLowMcyName: search.ssrLowMcyName,
          ssrSignal: search.ssrSignal,
        },
      });
    },
  });

  // // 함형 선택 변경
  // const handleShipTypeSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
  //   setSearch({
  //     startDate: search.startDate,
  //     endDate: search.endDate,
  //     ssrShiptypeName: e.target.value,
  //   });
  // };

  // // 함정 선택 변경
  // const handleShipSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
  //   setSearch({
  //     startDate: search.startDate,
  //     endDate: search.endDate,
  //     ssrShiptypeName: search.ssrShiptypeName,
  //     ssrShipName: e.target.value,
  //   });
  // };

  // 장비 선택 변경
  const handleMcySelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setSearch({
      ...search,
      ssrMcyName: e.target.options[e.target.selectedIndex].text,
      ssrMachine: e.target.value,
    });
  };

  // 하위장비 선택 변경
  const handleLowMcySelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setSearch({
      ...search,
      ssrLowMcyName: e.target.value,
    });
  };

  // 센서 선택 변경
  const handleSensorSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setSearch({
      ...search,
      ssrName: e.target.value,
    });
  };

  // 센서 값 및 날짜 변경
  const handleValueChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setSearch({
      ...search,
      [name]: value,
    });
  };
  // 상태변경 자유 함수
  const setSearchData = (key: string, value: any) => {
    setSearch((prevSearch) => ({
      ...prevSearch,
      [key]: value,
    }));
  };

  return {
    search,

    // /** 함형 select options */
    // shipTypeSelectOptions,

    // /** 함정 select options */
    // shipSelectOptions,

    /** 장비 select options */
    machinerySelectOptions,

    /** 하위장비 select options */
    lowMachinerySelectOptions,

    /** 센서 select options */
    sensorSelectOptions,

    // /** 함형 선택 변경 */
    // handleShipTypeSelectChange,

    // /** 함정 선택 변경 */
    // handleShipSelectChange,

    /** 장비 선택 변경 */
    handleMcySelectChange,

    /** 하위장비 선택 변경 */
    handleLowMcySelectChange,

    /** 센서 선택 변경 */
    handleSensorSelectChange,

    /** 센서 값 및 날짜 변경*/
    handleValueChange,
    setSearchData,
  };
};

export default useSensorSearchInputData;
